export type DownloadedFile = {
  blob: Blob;
  filename: string;
};

export function parseAttachmentFilename(
  contentDisposition: string | null,
  fallback: string,
): string {
  const match = contentDisposition?.match(/filename="?([^";]+)"?/);
  return match?.[1] ?? fallback;
}

export async function toDownloadError(response: Response): Promise<Error & { status: number }> {
  let message = `HTTP ${response.status}`;
  const body = await response.text();
  if (response.headers.get("Content-Type")?.includes("application/json")) {
    let parsed: { error?: unknown };
    try {
      parsed = JSON.parse(body) as { error?: unknown };
    } catch (cause) {
      throw new Error(`Export failed with HTTP ${response.status}: malformed JSON error body`, {
        cause,
      });
    }
    if (typeof parsed.error === "string") message = parsed.error;
  }
  const error = new Error(message) as Error & { status: number };
  error.status = response.status;
  return error;
}

export async function readDownload(response: Response, fallback: string): Promise<DownloadedFile> {
  if (!response.ok) {
    throw await toDownloadError(response);
  }
  return {
    blob: await response.blob(),
    filename: parseAttachmentFilename(response.headers.get("Content-Disposition"), fallback),
  };
}
